// import React, { useEffect, useState } from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import SearchBar from "../components/SearchBar";

interface Props {
  children: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  // const [loadingWordIndex, setLoadingWordIndex] = useState(0);
  // const words = ['Effortless Holiday Search', 'Unbeatable Prices', 'Support You Can Count On'];
  // const [letterIndex, setLetterIndex] = useState(0);
  // const [currentDisplay, setCurrentDisplay] = useState('');

  // useEffect(() => {
  //   const fullText = words[loadingWordIndex];
  //   const interval = setInterval(() => {
  //     if (letterIndex <= fullText.length) {
  //       const currentText = fullText.slice(0, letterIndex);
  //       // Find the first space to determine the end of the first word
  //       const firstSpaceIndex = currentText.indexOf(' ') !== -1 ? currentText.indexOf(' ') + 1 : currentText.length;
  //       // Wrap the first word with a span for styling
  //       const firstWord = `<span class="text-halo-pink block text-3xl md:inline">${currentText.slice(0, firstSpaceIndex)}</span>`;
  //       // Style the rest of the text for mobile view
  //       const restOfText = `<span class="text-2xl md:text-3xl block md:inline">${currentText.slice(firstSpaceIndex)}</span>`;
  //       setCurrentDisplay(firstWord + restOfText);
  //       setLetterIndex(letterIndex + 1);
  //     } else {
  //       clearInterval(interval);
  //       setTimeout(() => {
  //         setLoadingWordIndex((loadingWordIndex + 1) % words.length);
  //         setLetterIndex(0);
  //       }, 3000); // Pause before transitioning to the next phrase
  //     }
  //   }, 80);

  //   return () => clearInterval(interval);
  // }, [letterIndex, loadingWordIndex]);

  return (
    <div className="flex flex-col">
      <Header />
      <div className="min-h-[92vh] custom-min-height md:min-h-[20px] container mx-auto px-5">
        <h1 className="mt-24 -mb-24 text-center md:min-h-[3rem] min-h-[4.5rem] font-semibold text-2xl md:text-3xl">
          {/* // dangerouslySetInnerHTML={{ __html: currentDisplay }}> */}
          Find Your Dream <span className='text-halo-pink'>All Inclusive</span> Holidays
        </h1>
        <SearchBar/>
      </div>
      <div className="container mx-auto py-10 flex-1">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
